import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function DislikeColorIcon({ className, style, ...props }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 24 25'
      fill='none'
      {...props}
    >
      <path
        d='M16.9991 13.5472L12.9991 22.5472C12.2034 22.5472 11.4403 22.2312 10.8777 21.6686C10.3151 21.1059 9.99905 20.3429 9.99905 19.5472V15.5472H4.33905C4.04915 15.5505 3.76199 15.4907 3.49748 15.372C3.23297 15.2533 2.99744 15.0785 2.8072 14.8597C2.61695 14.6409 2.47655 14.3834 2.39571 14.105C2.31488 13.8266 2.29555 13.5339 2.33905 13.2472L3.71905 4.24724C3.79138 3.77033 4.03362 3.33563 4.40115 3.02323C4.76868 2.71083 5.23673 2.54178 5.71905 2.54724H16.9991M16.9991 13.5472V2.54724M16.9991 13.5472H19.6691C20.235 13.5572 20.785 13.3591 21.2145 12.9904C21.644 12.6217 21.9232 12.1082 21.9991 11.5472V4.54724C21.9232 3.9863 21.644 3.47274 21.2145 3.10405C20.785 2.73537 20.235 2.53723 19.6691 2.54724H16.9991'
        stroke='#F9FBFE'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
